(() => {
  const galleries = new WeakMap();

  function initialize(scope) {
    const roots = scope.matches?.('.hatchill-product-page')
      ? [scope]
      : scope.querySelectorAll('.hatchill-product-page');

    for (const root of roots) {
      if (galleries.has(root)) continue;
      let frame;
      const update = () => {
        frame = null;
        const gallery = root.querySelector('.swiper-main');
        const slide = gallery?.querySelector('.swiper-slide-active')
          || gallery?.querySelector('.product-media-container');
        const image = slide?.querySelector('.product-media__image');
        const ratio = Number(slide?.style.getPropertyValue('--media-preview-ratio'))
          || (image?.naturalWidth / image?.naturalHeight);
        if (Number.isFinite(ratio) && ratio > 0) {
          const value = String(ratio);
          if (root.style.getPropertyValue('--hp-media-ratio') !== value) {
            root.style.setProperty('--hp-media-ratio', value);
          }
        }
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };
      const observer = new MutationObserver(schedule);
      observer.observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class'],
      });
      root.addEventListener('load', schedule, true);
      update();
      galleries.set(root, () => {
        observer.disconnect();
        root.removeEventListener('load', schedule, true);
        if (frame) cancelAnimationFrame(frame);
        galleries.delete(root);
      });
    }
  }

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.querySelector('.hatchill-product-page');
    if (root) galleries.get(root)?.();
  });
})();
